import styled from 'styled-components';
import { FC, useEffect, useRef, useState } from 'react';
import { media } from 'src/styles/designs';
import { Swiper, SwiperProps } from 'swiper/react';
import { Theme } from 'vendor/mods/styled-components';
import { darkTheme } from 'src/styles/theme';
import { NavigationButton } from 'src/modules/materials/components/ShowcasePage/common';
import { ChevronLeft } from 'src/components/icons/ChevronLeft';
import { ChevronRight } from 'src/components/icons/ChevronRight';
import SwiperClass from 'swiper/types/swiper-class';
import { StyleProps } from '@summer/jst-react';

const StyledSwiper = styled(Swiper)`
  position: relative;
  left: 0;
  overflow: visible;
  ${media.w.greaterThanOrEqual.desktop} {
    display: flex;
    justify-content: center;

    .swiper-wrapper {
      width: max-content;
    }
  }
`;

export const ContentSwiper: FC<SwiperProps & StyleProps> = ({
  children,
  ...props
}) => {
  const prevRef = useRef<HTMLButtonElement>();
  const nextRef = useRef<HTMLButtonElement>();

  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  useEffect(() => {
    if (swiper && prevRef.current && nextRef.current && swiper.navigation) {
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [swiper]);

  return (
    <StyledSwiper
      threshold={15}
      slidesPerView="auto"
      watchSlidesProgress
      wrapperTag="ul"
      onSwiper={setSwiper}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      {...props}
    >
      {children}

      <Theme theme={darkTheme}>
        <NavigationButton
          kind="circled"
          ref={prevRef}
          icon={ChevronLeft}
          $direction="left"
        />
        <NavigationButton
          kind="circled"
          ref={nextRef}
          icon={ChevronRight}
          $direction="right"
        />
      </Theme>
    </StyledSwiper>
  );
};
